module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Totally"), _c('br'), _vm._v("Washi!")]), _vm._v(" "), _c('h2', {
    staticClass: "title1"
  }, [_vm._v("More than 45 Super Cute Washi Tape Crafts For Kids")]), _vm._v(" "), _c('h2', {
    staticClass: "author"
  }, [_vm._v("Ashley Ann Laz")]), _vm._v(" "), _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "alt": "Logo",
      "src": "images/29500.gif"
    }
  }), _c('br'), _vm._v("Avon, Massachusetts")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52eac582","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tp.vue
// module id = 57
// module chunks = 0